import { DocumentTypeId, DocumentType } from 'types'

export const getCodeForDocumentTypeId = (documentTypes: DocumentType[], documentTypeId: DocumentTypeId): string => {
  return documentTypes.find(_ => _.id === documentTypeId)?.code ?? ''
}

export const getIdForDocumentTypeCode = (documentTypes: DocumentType[], documentTypeName: string): DocumentTypeId => {
  return documentTypes.find(_ => _.code === documentTypeName)?.id ?? ''
}
